import Swal from 'sweetalert2';
import { authHeader } from './authHeader';
import ReactDOM from 'react-dom';
import Loader from '../Components/Loader';
import { Fragment } from 'react';


var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const ReinscripcionVista = {
    obtenerLaReinscripcion: async id => {
        let url = url_json + "/reinscripcion/" + id
        let request = {
            method:'GET',
            headers: authHeader()
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarReinscripcion: async (data, id) => {
        return Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar los datos de reinscripcion?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                ReactDOM.render(
                    <div className='loader_padre'>
                        <Loader />
                    </div>,
                    document.getElementById("loader_padre")
                );

                let url = url_json + "/reinscripcion/" + id;

                // horario_especial_pdf no va aquí: se guarda con guardarHorarioEspecialPdf para no pisar un PDF recién subido
                let body = {
                    fecha_limite_reinscripcion: data.fecha_limite_reinscripcion,
                    dia_limite_colegiatura: Number(data.dia_limite_colegiatura),
                    fecha_limite_cita_virtual: data.fecha_limite_cita_virtual,
                    horario_presencial_fechas: data.horario_presencial_fechas,
                    horario_presencial_horas: data.horario_presencial_horas,
                    horario_en_linea: data.horario_en_linea,
                    reingreso_fecha_limite: data.reingreso_fecha_limite,
                    reingreso_fecha_respuesta: data.reingreso_fecha_respuesta,
                    calendario_vigente: data.calendario_vigente,
                    dias_pago_contado: Number(data.dias_pago_contado),
                    cine_reinscripcion: Number(data.cine_reinscripcion),
                    cine_reinscripcion_tardia: Number(data.cine_reinscripcion_tardia),
                    cine_colegiatura: Number(data.cine_colegiatura),
                    cine_colegiatura_tardia: Number(data.cine_colegiatura_tardia),
                    cine_total_colegiaturas: Number(data.cine_total_colegiaturas),
                    cine_total_contado: Number(data.cine_total_contado),
                    marketing_reinscripcion: Number(data.marketing_reinscripcion),
                    marketing_reinscripcion_tardia: Number(data.marketing_reinscripcion_tardia),
                    marketing_colegiatura: Number(data.marketing_colegiatura),
                    marketing_colegiatura_tardia: Number(data.marketing_colegiatura_tardia),
                    marketing_total_colegiaturas: Number(data.marketing_total_colegiaturas),
                    marketing_total_contado: Number(data.marketing_total_contado),
                    costo_extraordinario: Number(data.costo_extraordinario),
                    materia_repetir_costo: Number(data.materia_repetir_costo),
                    materia_repetir_tardio_1_fechas: data.materia_repetir_tardio_1_fechas,
                    materia_repetir_tardio_1_costo: Number(data.materia_repetir_tardio_1_costo),
                    materia_pendiente_tardio_1_cargo: Number(data.materia_pendiente_tardio_1_cargo),
                    materia_repetir_tardio_2_fechas: data.materia_repetir_tardio_2_fechas,
                    materia_repetir_tardio_2_costo: Number(data.materia_repetir_tardio_2_costo),
                    materia_pendiente_tardio_2_cargo: Number(data.materia_pendiente_tardio_2_cargo)
                };
                let request = {
                    method: 'PATCH',
                    body: JSON.stringify(body),
                    headers: authHeader()
                }

                let response = await fetch(url, request);
                let res = await response.json();

                ReactDOM.render(
                    <Fragment></Fragment>,
                    document.getElementById("loader_padre")
                );

                if (response.ok) {
                    Swal.fire(
                        'Modificación exitosa!',
                        'Datos de reinscripcion modificados correctamente' ,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudieron modificar los datos de reinscripcion' ,
                        'error'
                    )
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Modificación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        });
    },
    guardarHorarioEspecialPdf: async (id, url) => {
        let response = await fetch(url_json + "/reinscripcion/" + id, {
            method: 'PATCH',
            body: JSON.stringify({ horario_especial_pdf: url }),
            headers: authHeader()
        });
        let res = await response.json();
        if (response.ok) {
            Swal.fire('Modificación exitosa!', 'El PDF de horario especial se actualizó correctamente', 'success')
        } else {
            Swal.fire('Error!', 'No se pudo actualizar el PDF de horario especial', 'error')
        }
        return { success: response.ok, data: res.data };
    }
}

export default ReinscripcionVista;
